module.exports = __webpack_public_path__ + "img/storage_100.dfec9fa5.jpg";